import { FeedItemTypePipPriorityMap } from '~/constants/home';
import { BffFeedItem } from '~/contracts/home';

export default function getHighestPriorityPipFeedItem(
  feedItems: BffFeedItem[]
): BffFeedItem | null {
  if (!feedItems || feedItems.length === 0) return null;

  return feedItems.reduce<BffFeedItem | null>(
    (highestPriorityItem, currentItem) => {
      const currentPriority = FeedItemTypePipPriorityMap[currentItem.type];
      const highestPriority = highestPriorityItem
        ? FeedItemTypePipPriorityMap[highestPriorityItem.type]
        : null;

      if (!highestPriority || currentPriority < highestPriority) {
        return currentItem;
      }

      return highestPriorityItem;
    },
    null
  );
}
